import axios from "axios";

import store from "../store/store";

/* Configuration Data Structure
{
    device_name: "",
    device_model: "",
    serial_number: "",
    refresh_rate: "",
    sensor_1: {
        name: "",
        limits_enabled: false,
        sensor_type: {
            name: "",
            is_boolean: false,
            index: 1,
            parameters: [{
                name: "",
                minimum: "",
                maximum: "",
                unit: "",
                step: 1,
                lower_value: -,
                upper_value: -,
                slider: [10, 20]
            }, {
                name: "",
                minimum: "",
                maximum: "",
                unit: "",
                step: 1,
                lower_value: -,
                upper_value: -,
                slider: [10, 20]
            }]
        },
    },
    sensors_available:[{
        id: 1,
        name: "Temperature",
        index: 2,
        is_boolean: false

    }],
}

*/

var getSensorWithIndex = (sensorsAvailable, index) => {
    for(var i = 0; i < sensorsAvailable.length; i++) {
        if(sensorsAvailable[i].index == index)
            return sensorsAvailable[i];
    }
}

const getParameters = (sensor, setCurrentReadings) => {
    if (typeof setCurrentReadings == "undefined")
        setCurrentReadings = true;
    var url = process.env.VUE_APP_API + "sensors/parameters/?sensor_name="+sensor.sensor_type.name;
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken
        }
    };

    return axios.get(url, headers).then(response => {
        sensor.sensor_type.parameters = response.data;
        sensor.sensor_type.parameters.forEach(function(parameter){
            if (setCurrentReadings) {
                parameter.upper_value = sensor["limit_"+(parameter.order_in_sensor + 1)+"_upper"];
                parameter.lower_value = sensor["limit_"+(parameter.order_in_sensor + 1)+"_lower"];
                if (parameter.upper_value < parameter.minimum || parameter.upper_value > parameter.maximum) {
                    parameter.upper_value = parameter.maximum;
                }
                if (parameter.lower_value < parameter.minimum || parameter.lower_value > parameter.maximum) {
                    parameter.lower_value = parameter.minimum;
                }
            } else {
                parameter.upper_value = parameter.maximum;
                parameter.lower_value = parameter.minimum;
            }

            // Check if the sensor is boolean
            if(sensor.sensor_type.is_boolean){
                parameter.upper_value = sensor.sensor_type.true_message;
                parameter.lower_value = sensor.sensor_type.false_message;
                parameter.slider = 0;
                if(setCurrentReadings){
                    parameter.slider = sensor.limit_4_normal_state? 0:1;
                }
            }
            else {
                parameter.slider = [parameter.lower_value, parameter.upper_value];
            }
        })
        return sensor.sensor_type;
    });
}

const getSensors = (configuration) => {
    var url = process.env.VUE_APP_API + "sensors/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken,
        }
    };

    return axios.get(url, headers).then(response => {
        configuration.sensors_available = response.data;
    });
}

const getManufacturers = (configuration) => {
    var url = process.env.VUE_APP_API + "manufacturers/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken
        }
    };
    return axios.get(url, headers).then(response => {
        configuration.control.manufacturers = response.data;
    });
}

const getDeviceTypes = (configuration) => {
    var url = process.env.VUE_APP_API + "manufacturers/types/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken
        }
    };
    return axios.get(url, headers).then(response => {
        configuration.control.device_types = response.data;
    });
}

const getControlledDevice = (serialNumber, configuration) => {
    var url = process.env.VUE_APP_API + "devices/" + serialNumber + "/controlled-devices/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken
        }
    };
    return axios.get(url, headers).then(response => {
        configuration.control.installedController = response.data;
        getModels(
            configuration,
            response.data.manufacturer_model.manufacturer.id,
            response.data.manufacturer_model.manufacturer_type.id
        )
    });
}

const getModels = (configuration, manufacturerID, deviceTypeID, resetControlledDevice) => {
    if (!resetControlledDevice) {
        resetControlledDevice = false;
    }
    var url = process.env.VUE_APP_API + "manufacturers/" + manufacturerID;
    url += "/types/" + deviceTypeID + "/models/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken,
        }
    };
    return axios.get(url, headers).then(response => {
        configuration.control.models = response.data;
        if(resetControlledDevice) {
            configuration.control.installedController.manufacturer_model.id = null;
        }
        return response.data;
    });
}

const updateSensor = (config, sensorConfig) => {
    var sensor = {
        sensor_type: {},
    };
    var sensorType = getSensorWithIndex(config.sensors_available, sensorConfig.type_index);
    sensor["sensor_type"] = JSON.parse(JSON.stringify(sensorType));
    getParameters(sensor).then(() => {
        sensorConfig = sensor;
    });
}

const getConfiguration = async (serialNumber, configuration) => {
    var url = process.env.VUE_APP_API + "devices/" + serialNumber + "/configurations/";
    var headers = {
        headers: {
            Authorization: "JWT " + store.getters.getToken
        }
    };
    var ambientSensor = {
        sensor_type: {},
    };
    var sensor1 = {
        sensor_type: {},
    };
    var sensor2 = {
        sensor_type: {},
    };
    var sensor3 = {
        sensor_type: {},
    };
    var sensor4 = {
        sensor_type: {},
    };
    var tempConfiguration = null
    var configurationPromise = await axios.get(url, headers).then(response => {
        tempConfiguration = response.data;
        configuration.serial_number =  serialNumber;
        configuration.device_model = tempConfiguration.device_model;
        configuration.device_name = tempConfiguration.device_name;
        configuration.refresh_rate = tempConfiguration.refresh_rate;
        var setLimits = function(sensorObject, config, configKey) {
            sensorObject.name = config[configKey].name;
            sensorObject.limits_enabled = config[configKey].limits_enabled;
            sensorObject.limit_1_upper = config[configKey].limit_1_upper;
            sensorObject.limit_1_lower = config[configKey].limit_1_lower;
            sensorObject.limit_2_upper = config[configKey].limit_2_upper;
            sensorObject.limit_2_lower = config[configKey].limit_2_lower;
            sensorObject.limit_3_upper = config[configKey].limit_3_upper;
            sensorObject.limit_3_lower = config[configKey].limit_3_lower;
            sensorObject.limit_4_normal_state = config[configKey].limit_4_normal_state;
        }
        setLimits(ambientSensor, tempConfiguration, 'ambient_sensor');
        setLimits(sensor1, tempConfiguration, 'sensor_1');
        setLimits(sensor2, tempConfiguration, 'sensor_2');
        setLimits(sensor3, tempConfiguration, 'sensor_3');
        setLimits(sensor4, tempConfiguration, 'sensor_4');
    });
    await getSensors(configuration).then(() => {
        // Ambient Sensor
        var sensorType = getSensorWithIndex(configuration.sensors_available, tempConfiguration.ambient_sensor.type_index);
        ambientSensor["sensor_type"] = JSON.parse(JSON.stringify(sensorType));
        getParameters(ambientSensor).then(() => {
            configuration.ambient_sensor = ambientSensor;
        });

        // Sensor 1
        var sensorType1 = getSensorWithIndex(configuration.sensors_available, tempConfiguration.sensor_1.type_index);
        sensor1["sensor_type"] = JSON.parse(JSON.stringify(sensorType1));
        getParameters(sensor1).then(() => {
            configuration.sensor_1 = sensor1;
        });

        // Sensor 2
        var sensorType2 = getSensorWithIndex(configuration.sensors_available, tempConfiguration.sensor_2.type_index);
        sensor2["sensor_type"] = JSON.parse(JSON.stringify(sensorType2));
        getParameters(sensor2).then(() => {
            configuration.sensor_2 = sensor2;
        });

        // Sensor 3
        var sensorType3 = getSensorWithIndex(configuration.sensors_available, tempConfiguration.sensor_3.type_index);
        sensor3["sensor_type"] = JSON.parse(JSON.stringify(sensorType3));
        getParameters(sensor3).then(() => {
            configuration.sensor_3 = sensor3;
        });

        //Sensor 4
        var sensorType4 = getSensorWithIndex(configuration.sensors_available, tempConfiguration.sensor_4.type_index);
        sensor4["sensor_type"] = JSON.parse(JSON.stringify(sensorType4));
        getParameters(sensor4).then(() => {
            configuration.sensor_4 = sensor4;
        });
    })

    return configurationPromise;
}

export { getDeviceTypes, getConfiguration, getControlledDevice, getManufacturers, getParameters, updateSensor, getModels };
